import React, { useEffect, useLayoutEffect } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Select from '@atlaskit/select';
import { defaultSelectStyles } from '@atlassian/jira-issue-field-select-base/src/ui/react-select-styles/styled.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { Props } from './types.tsx';

const IssueLinksTypeControl = (props: Props) => {
	const {
		options,
		value,
		onChange,
		autoFocus = false,
		onCloseMenuOnScroll,
		isDropdownMenuFixedAndLayered,
		isDisabled,
		inputId,
		isRequired,
		ariaLabel,
		ariaLabelledBy,
		components,
		styles,
		openMenuOnFocus,
	} = props;

	useEffect(() => {
		if (value === undefined) {
			onChange(options[0]);
		}
	}, [value, onChange, options]);

	return (
		<Box xcss={linkTypeWrapperStyles}>
			<Select
				inputId={inputId}
				required={isRequired}
				{...(expVal('sunsetting_bulk_edit', 'isEnabled', false)
					? { components, openMenuOnFocus, styles: styles ?? defaultSelectStyles }
					: { styles: defaultSelectStyles })}
				options={options}
				value={value}
				// @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
				onChange={onChange}
				isMulti={false}
				autoFocus={autoFocus}
				defaultValue={options[0]}
				closeMenuOnScroll={onCloseMenuOnScroll}
				menuPosition={isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined}
				isDisabled={isDisabled}
				classNamePrefix="issue-link-type"
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
			/>
		</Box>
	);
};

const IssueLinksTypeExperiment = (props: Props) => {
	const {
		options,
		value,
		onChange,
		autoFocus = false,
		onCloseMenuOnScroll,
		isDropdownMenuFixedAndLayered,
		isDisabled,
		inputId,
		isRequired,
		ariaLabel,
		ariaLabelledBy,
		components,
		styles,
		openMenuOnFocus,
	} = props;

	useLayoutEffect(() => {
		if (value === undefined && options?.length) {
			onChange(options[0]);
		}
	}, [value, onChange, options]);

	return (
		<Box xcss={linkTypeWrapperStyles}>
			<Select
				inputId={inputId}
				required={isRequired}
				options={options}
				value={value}
				// @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
				onChange={onChange}
				isMulti={false}
				autoFocus={autoFocus}
				defaultValue={options[0]}
				closeMenuOnScroll={onCloseMenuOnScroll}
				{...(expVal('sunsetting_bulk_edit', 'isEnabled', false)
					? { components, openMenuOnFocus, styles: styles ?? defaultSelectStyles }
					: { styles: defaultSelectStyles })}
				menuPosition={isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined}
				isDisabled={isDisabled}
				classNamePrefix="issue-link-type"
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
			/>
		</Box>
	);
};

const IssueLinksType = (props: Props): React.JSX.Element => {
	if (fg('create_another_issue_react_18_fix')) {
		return <IssueLinksTypeExperiment {...props} />;
	}
	return <IssueLinksTypeControl {...props} />;
};

export default IssueLinksType;

const linkTypeWrapperStyles = xcss({
	width: '100%',
	marginBottom: 'space.100',
});
